import { Store, applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import type { RootState } from './@types';
import rootReducer from './reducers';
import { SearchAction, initialState } from './reducers/searchReducer';

const composeEnhancers =
	typeof window === 'object' && globalThis.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
		? globalThis.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
				// Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
				features: {
					pause: true,
					// start/pause recording of dispatched actions
					lock: false,
					// lock/unlock dispatching actions and side effects
					persist: true,
					// persist states on page reloading
					export: true,
					// export history of actions in a file
					import: false,
					// import history of actions from a file
					jump: true,
					// jump back and forth (time travelling)
					skip: true,
					// skip (cancel) actions
					reorder: false,
					// drag and drop actions in the history list
					dispatch: true,
					// dispatch custom actions or action creators
					test: false, // generate tests for the selected actions.
				}, // other options like actionSanitizer, stateSanitizer
				// More information:- https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Arguments.md#options
			})
		: compose;

const enhancer = composeEnhancers(applyMiddleware(thunk));

/**
 * This is root action type
 * Any future actions will be added here in union
 */
type RootAction = SearchAction;

const store: Store<RootState, RootAction> = createStore(rootReducer, { search: initialState }, enhancer);

export default store;
